import { t } from "../../i18n";
import { fmt } from "@tasduvar/engine";
import { useLocation, useNavigate } from "react-router-dom";
import { useProjectStore } from "../../state/projectStore";
import { useCadUi } from "../../state/cadUiStore";
import { useAutoSizeStore } from "../../state/useAutoSize";
import { runAnalysis } from "../../state/useAnalysis";
import { useWizardStore } from "../../state/wizardStore";
import { SmartStartDialog } from "../smart-start/SmartStartDialog";
import { applySmartToWall, scannable } from "../smart-start/smartStart";

/**
 * Proje içinden sihirbaz (CadShell'de bir kez monte): `useWizardStore.open(wallId)` ile açılır, seçilen duvara yazar.
 * "Analize başla" → değerler duvara + rapordaki boş künye alanları / seçilen konum künyeye (birlikte tek geri alma adımı), taranabilir tipte Akıllı tasarım paftası + taze tarama (en ekonomik
 * aday kendiliğinden uygulanır); payandalı / çokgen kesitte Model paftasında kalınır, yalnız zemin ve yükler yazılır.
 */
export function WizardMount(): JSX.Element | null {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const wallId = useWizardStore((s) => s.wallId), close = useWizardStore((s) => s.close);
  const project = useProjectStore((s) => s.project), readOnly = useProjectStore((s) => s.readOnly);
  const wall = project?.walls.find((w) => w.id === wallId);
  if (!project || !wall || readOnly) return null;
  const saved = useAutoSizeStore.getState().inputs[wall.id];
  const res = runAnalysis(wall).result;
  const height = saved?.height ?? (res ? Math.round(res.geometry.yTop * 100) / 100 : 3);
  return (
    <SmartStartDialog key={wall.id} open onClose={close} info={project.info} target={{ wall, height, fixedH: !scannable(wall) }}
      onStart={(infoPatch, seismic, start) => {
        const r = applySmartToWall(wall.id, start, seismic, infoPatch);
        close();
        if (!r.applied) return;
        const cad = useCadUi.getState();
        if (pathname.endsWith("/rapor")) nav(`/proje/${project.id}`);
        cad.setRibbonTab("home");
        const filled = Object.keys(infoPatch).length ? ` · ${t("künye tamamlandı")}` : "";
        if (r.scan) {
          cad.setLayout("design");
          cad.pushHistory({ text: `${t("SİHİRBAZ")}  ${wall.name}: ${t("zemin ve yükler yazıldı")}${filled} · H = ${fmt(start.height, 2)} m — ${t("boyutlandırılıyor…")}`, tone: "ok" });
        } else {
          if (cad.layout !== "model") cad.setLayout("model");
          cad.pushHistory({ text: `${t("SİHİRBAZ")}  ${wall.name}: ${t("zemin ve yükler yazıldı (payandalı / çokgen kesitte otomatik boyutlandırma yok)")}${filled}`, tone: "ok" });
        }
      }} />
  );
}
